import { render, staticRenderFns } from "./DialogApuracaoContratoNdsGeradas.vue?vue&type=template&id=08817451"
import script from "./DialogApuracaoContratoNdsGeradas.vue?vue&type=script&lang=js"
export * from "./DialogApuracaoContratoNdsGeradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports